import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DepartmentModel } from '../model/department.model';
import { DepartmentService } from '../department.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { PermissionService } from 'src/app/auth/permission.service';
@Component({
  selector: 'app-department-edit',
  templateUrl: './department-edit.component.html',
  styleUrls: ['./department-edit.component.scss'],
  standalone: false
})
export class DepartmentEditComponent implements DirtyCheck {
  title: string = "New Department";
  editForm: FormGroup;
  departmentInfo: DepartmentModel = {};
  isFormDirty: boolean = false;
  ratingList: DepartmentModel[] = [];
  permission: any;

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private DepartmentService: DepartmentService,
    private snackBarService: SnackBarService,
    private permissionService: PermissionService,
    public dialog: MatDialog,) {

    let departmentId = this.route.snapshot.paramMap.get('id');
    this.editForm = this.builder.group({
      code: this.builder.control(this.departmentInfo.code, [Validators.required, Validators.maxLength(10)]),
      name: this.builder.control(this.departmentInfo.name, [Validators.required, Validators.maxLength(50)]),
      description: this.builder.control(this.departmentInfo.description)


    });

    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });

    if (departmentId !== null && parseInt(departmentId) !== 0) {
      this.setDepartmentInfo(departmentId);
    }
    this.permission = permissionService.getPagePermission('department');
  }
  ngOnInit(): void {
    //  this.loadRating();    
  }

  /**
   * Dirtyness check
   * @returns 
   */
  isDirty(): boolean {
    return this.isFormDirty;
  }

  /**
   * checks the form is edited
   */
  navBack(): void {

    this.router.navigate(['/system/department']);

  }

  /**
   * If tas is is null set an empty department info
   * if department id is not null call api to rtrive the info
   * @param departmentId 
   */
  setDepartmentInfo(departmentId: any): void {

    let response = this.DepartmentService.getDepartmentById(departmentId).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.departmentInfo = response.data.department;
          this.editForm.patchValue(this.departmentInfo);
          this.title = this.getTitle();
          this.isFormDirty = false;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to get data from server. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }

  /**
   * 
   * @returns  the title for the dialog
   * sine the same dialog is used for edit and new, dynamically decide the title
   */
  getTitle(): string {
    let title = (this.departmentInfo.id == 0) ? "New Department" : "Editing : " + this.departmentInfo.name;
    return title;
  }

  /**
     * On save
     * if the details are valid call the api to update the changes.
     */
  save(): void {

    if (this.editForm.valid) {
      this.editForm.markAllAsTouched();
      Object.assign(this.departmentInfo, this.editForm.value);
      this.DepartmentService.update(this.departmentInfo).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            // handle success
            this.isFormDirty = false;
            let snckBarData: SnackBarData = {
              type: 'success',
              title: 'Saved',
              message: 'The record for ' + this.departmentInfo.name + " has been updated succesfully."
            }
            this.snackBarService.openSnackBar(snckBarData);
            this.router.navigate(['/system/department']);

          } else {
            let snackBarData: SnackBarData = {
              message: response.message,
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);


          }
        },
        error: (error) => {
          // handle error
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });

    } else {
      this.editForm.markAllAsTouched();
    }
  }

}
